import AccessLevel from '../enums/access-level';

class AuthUser {
    constructor(public username: string, public access: AccessLevel, public userId: number) {
    }
}

export default AuthUser;
